export const blockIconsCommunicationVpnKey = (
	<span className='material-symbols-outlined'>vpn_key</span>
);
